

export const ETATS_USA = [
  { code: 'AL', nom: 'Alabama', capitale: 'Montgomery' },
  { code: 'AK', nom: 'Alaska', capitale: 'Juneau' },
  { code: 'AZ', nom: 'Arizona', capitale: 'Phoenix' },
  { code: 'AR', nom: 'Arkansas', capitale: 'Little Rock' },
  { code: 'CA', nom: 'Californie', capitale: 'Sacramento' },
  { code: 'CO', nom: 'Colorado', capitale: 'Denver' },
  { code: 'CT', nom: 'Connecticut', capitale: 'Hartford' },
  { code: 'DE', nom: 'Delaware', capitale: 'Dover' },
  { code: 'FL', nom: 'Floride', capitale: 'Tallahassee' },
  { code: 'GA', nom: 'Géorgie', capitale: 'Atlanta' },
  { code: 'HI', nom: 'Hawaï', capitale: 'Honolulu' },
  { code: 'ID', nom: 'Idaho', capitale: 'Boise' },
  { code: 'IL', nom: 'Illinois', capitale: 'Springfield' },
  { code: 'IN', nom: 'Indiana', capitale: 'Indianapolis' },
  { code: 'IA', nom: 'Iowa', capitale: 'Des Moines' },
  { code: 'KS', nom: 'Kansas', capitale: 'Topeka' },
  { code: 'KY', nom: 'Kentucky', capitale: 'Frankfort' },
  { code: 'LA', nom: 'Louisiane', capitale: 'Baton Rouge' },
  { code: 'ME', nom: 'Maine', capitale: 'Augusta' },
  { code: 'MD', nom: 'Maryland', capitale: 'Annapolis' },
  { code: 'MA', nom: 'Massachusetts', capitale: 'Boston' },
  { code: 'MI', nom: 'Michigan', capitale: 'Lansing' },
  { code: 'MN', nom: 'Minnesota', capitale: 'Saint Paul' },
  { code: 'MS', nom: 'Mississippi', capitale: 'Jackson' },
  { code: 'MO', nom: 'Missouri', capitale: 'Jefferson City' },
  { code: 'MT', nom: 'Montana', capitale: 'Helena' },
  { code: 'NE', nom: 'Nebraska', capitale: 'Lincoln' },
  { code: 'NV', nom: 'Nevada', capitale: 'Carson City' },
  { code: 'NH', nom: 'New Hampshire', capitale: 'Concord' },
  { code: 'NJ', nom: 'New Jersey', capitale: 'Trenton' },
  { code: 'NM', nom: 'Nouveau-Mexique', capitale: 'Santa Fe' },
  { code: 'NY', nom: 'New York', capitale: 'Albany' },
  { code: 'NC', nom: 'Caroline du Nord', capitale: 'Raleigh' },
  { code: 'ND', nom: 'Caroline du Nord', capitale: 'Bismarck' },
  { code: 'OH', nom: 'Ohio', capitale: 'Columbus' },
  { code: 'OK', nom: 'Oklahoma', capitale: 'Oklahoma City' },
  { code: 'OR', nom: 'Oregon', capitale: 'Salem' },
  { code: 'PA', nom: 'Pennsylvanie', capitale: 'Harrisburg' },
  { code: 'RI', nom: 'Rhode Island', capitale: 'Providence' },
  { code: 'SC', nom: 'Caroline du Sud', capitale: 'Columbia' },
  { code: 'SD', nom: 'Dakota du Sud', capitale: 'Pierre' },
  { code: 'TN', nom: 'Tennessee', capitale: 'Nashville' },
  { code: 'TX', nom: 'Texas', capitale: 'Austin' },
  { code: 'UT', nom: 'Utah', capitale: 'Salt Lake City' },
  { code: 'VT', nom: 'Vermont', capitale: 'Montpelier' },
  { code: 'VA', nom: 'Virginie', capitale: 'Richmond' },
  { code: 'WA', nom: 'Washington', capitale: 'Olympia' },
  { code: 'WV', nom: 'Virginie-Occidentale', capitale: 'Charleston' },
  { code: 'WI', nom: 'Wisconsin', capitale: 'Madison' },
  { code: 'WY', nom: 'Wyoming', capitale: 'Cheyenne' }
];
